import React from "react";
import {Card} from "react-bootstrap";

function SubList(props) {
    return (
        <div className="mb-3">
            <Card border={"muted"} bg={"light"}>
                <div className="m-lg-3">
                    <label className="form-label">{props.label}</label>
                    {props.children}
                </div>
            </Card>
        </div>
    )
}

export default SubList
